import { render, staticRenderFns } from "./CreatorPage.vue?vue&type=template&id=ad71a020&scoped=true"
import script from "./CreatorPage.vue?vue&type=script&lang=js"
export * from "./CreatorPage.vue?vue&type=script&lang=js"
import style0 from "./CreatorPage.vue?vue&type=style&index=0&id=ad71a020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad71a020",
  null
  
)

export default component.exports